(function ($) {
    window.fnames = [];
    window.ftypes = [];
    fnames[0] = 'EMAIL';
    ftypes[0] = 'email';
    fnames[1] = 'FNAME';
    ftypes[1] = 'text';
    fnames[2] = 'LNAME';
    ftypes[2] = 'text';
    fnames[3] = 'ADDRESS';
    ftypes[3] = 'address';
    fnames[4] = 'PHONE';
    ftypes[4] = 'phone';
    fnames[5] = 'BIRTHDAY';
    ftypes[5] = 'birthday';
    fnames[6] = 'LANG';
    ftypes[6] = 'text';
}(jQuery));
var $mcj = jQuery.noConflict(true);

/*******************************************************
 * LANGUAGE TRANSLATIONS
 *******************************************************/
if (HOVER.current_lang==='fr') {
    $mcj.extend($mcj.validator.messages, {
        required: "Ce champ est requis.",
        remote: "Ce champ n'est pas valide.",
        email: "L'adresse courriel n'est pas valide",
    });
}

// select the target node
var target = document.getElementById('mce-success-response');

// create an observer instance
var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (target.innerHTML==="Thank you for subscribing!" && HOVER.current_lang==='fr') {
            target.innerHTML = "Merci de vous être inscrit!";
        }
    });
});

// configuration of the observer:
var config = {attributes: true, childList: true, characterData: true};

// pass in the target node, as well as the observer options
observer.observe(target, config);
